import React from 'react';
import SectionHeader from '../../Basic/SectionHeader';
import ContactPersonPhone from './ContactPersonPhone';
const EmergencyContact = ({ disabled }) => {
    const lookup = window.osa.lookup.optionalCustomerDetails.emergencyContact;
    return (
        <div className="form-group">
            <SectionHeader title={lookup.title} />
            <p>{lookup.text}</p>
            <ContactPersonPhone name="emergencyContact" disabled={disabled} />
        </div>
    );

};
export default EmergencyContact;
